@if (loadingPreview()) {
    <app-spinner-overlay />
}

<div class="setup-container">
    @for (section of sections; track section.titleKey) {
        <app-notification-section
            [form]="form"
            [titleKey]="section.titleKey"
            [descriptionKey]="section.descriptionKey"
            [recipientsKey]="section.recipientsKey"
            [dates]="section.dates"
            [result]="section.result()"
            [previewDisabled]="loadingPreview()"
            (preview)="section.preview()">
            @if (section.titleKey === 'ADMIN.DAYS_LEFT.EMPLOYEE_REMINDER_TITLE') {
                <div class="custom-body-group" [formGroup]="form">
                    <div class="editor-header">
                        <div class="editor-header-label">
                            <mat-label>{{ 'ADMIN.DAYS_LEFT.CUSTOM_BODY_LABEL' | translate }}</mat-label>
                            <span class="custom-body-hint">{{ 'ADMIN.DAYS_LEFT.CUSTOM_BODY_HINT' | translate }}</span>
                        </div>
                        <mat-button-toggle-group
                            #formatToggle
                            [value]="form.controls.plannedLeavesCustomBodyFormat.value"
                            (change)="onBodyFormatChange($event.value)"
                            [disabled]="isConvertingBody()"
                            aria-label="Content format">
                            <mat-button-toggle value="HTML">HTML</mat-button-toggle>
                            <mat-button-toggle value="MARKDOWN">Markdown</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    @if (form.controls.plannedLeavesCustomBodyFormat.value === 'MARKDOWN') {
                        <app-markdown-editor formControlName="plannedLeavesCustomBody"></app-markdown-editor>
                    } @else {
                        <app-editor formControlName="plannedLeavesCustomBody"></app-editor>
                    }
                </div>
            }
            @if (section.titleKey === 'ADMIN.DAYS_LEFT.MONTHLY_INVOICES_REMINDER_TITLE') {
                <div class="custom-body-group" [formGroup]="form">
                    <div class="editor-header">
                        <div class="editor-header-label">
                            <mat-label>{{ 'ADMIN.DAYS_LEFT.CUSTOM_BODY_LABEL' | translate }}</mat-label>
                            <span class="custom-body-hint">{{ 'ADMIN.DAYS_LEFT.CUSTOM_BODY_HINT' | translate }}</span>
                        </div>
                    </div>
                    <app-editor formControlName="monthlyInvoicesCustomBody"></app-editor>
                </div>
            }
        </app-notification-section>
    }

    <div class="save-button-row">
        <button mat-raised-button color="primary" type="button" (click)="onSaveChanges()"
            [disabled]="!hasChanges() || !form.get('notification')?.value || !form.get('opsReminder')?.value || form.invalid">
            {{ 'ADMIN.DAYS_LEFT.SAVE_CHANGES' | translate }}
        </button>
    </div>
</div>
